import { Button, DialogActions, DialogContent, Skeleton } from "@mui/material";
import React from "react";
import { orderStatusFormatted } from "src/constant";
import useWarehouseTransferReview from "src/hooks/warehouse-transfer/useWarehouseTransferReview";
import DeliveredReceipt from "src/pages/orders/all-order/export-form/DeliveredReceipt";

export default function ExportInfoDialog({ id, onPrint }) {
  const { data, isLoading } = useWarehouseTransferReview(id, {
    transferFileType: orderStatusFormatted.Exported,
  });
  return (
    <>
      <DialogContent>
        {isLoading ? (
          Array.from({ length: 10 }, (_, i) => {
            return (
              <Skeleton
                key={i}
                width="100%"
                height="44px"
              />
            );
          })
        ) : (
          <DeliveredReceipt
            isLoading={isLoading}
            html={data}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ p: "0px 12px 24px" }}>
        <Button
          onClick={onPrint}
          fullWidth
          variant="contained"
        >
          In phiếu
        </Button>
      </DialogActions>
    </>
  );
}
